import { type ABTests } from '@fiverr-private/fiverr_context';
import { ROLLOUTS, type Rollouts } from '../../../types/rollouts';

export const isInGigBoosting = (rollouts: Rollouts, _abTests: ABTests): boolean =>
    rollouts[ROLLOUTS.STARLINGS_BOOSTING_NEW_GIGS];
